import request from '@/utils/request'

//用户注册
export function userRegistrationAPI(data) {
  return request({
    url: '/exam/user/register',
    method: 'post',
    data: data,
  })
}

//企业注册
export function companyRegistrationAPI(data) {
  return request({
    url: '/exam/user/company/register',
    method: 'post',
    data: data,
  })
}

//企业用户注册校验
export function userRefistrationCheckAPI(params) {
  return request({
    url: '/exam/user/search/company/person',
    method: 'get',
    params: params,
  })
}

//用户登录
export function userLoginAPI(data) {
  return request({
    url: '/exam/user/login',
    method: 'post',
    data: data,
  })
}

//一键登录
export function oauthLoginAPI(uid) {
  return request({
    url: '/exam/user/oauth/' + uid,
    method: 'get',
  })
}

//退出登录
export function userLogoutAPI(data) {
  return request({
    url: '/exam/user/logout',
    method: 'post',
    data: data,
  })
}

//用户登录
export function getPersonCompanyAPI(params) {
  return request({
    url: '/exam/user/search/person/company',
    method: 'get',
    params: params,
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/exam/captchaImage',
    headers: {
      isToken: false,
    },
    method: 'get',
    timeout: 20000,
  })
}
